import { createCustomEnum } from "./customEnum";

export type CommissionsColumnsDataTypes =
	| "string"
	| "decimal"
	| "data_time"
	| "integer";

const ColumnsDataTypes = createCustomEnum({
	String: {
		value: 0,
		name: "string",
		displayName: "String",
	},
	Decimal: {
		value: 1,
		name: "decimal",
		displayName: "Decimal",
	},
	DataTime: {
		value: 2,
		name: "data_time",
		displayName: "Date & Time",
	},
	Integer: {
		value: 3,
		name: "integer",
		displayName: "Integer",
	},
});

export default ColumnsDataTypes;
